import { render, staticRenderFns } from "./IssuesNavItem.vue?vue&type=template&id=488c46c1&"
import script from "./IssuesNavItem.vue?vue&type=script&lang=js&"
export * from "./IssuesNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports